// core
import { Inject, Injectable } from '@angular/core';
import { Observable, map, throwError } from 'rxjs';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';

// share
import { DynamicReportGeneralModel } from './dynamic-report-general.model';
import { DYNAMIC_REPORT_HTTP_LOADER, DynamicReportHttpLoader } from './dynamic-report-http-loader.service';

@Injectable()
export class DynamicReportGeneralResolver implements Resolve<DynamicReportGeneralModel> {
  constructor(@Inject(DYNAMIC_REPORT_HTTP_LOADER) private _apiService: DynamicReportHttpLoader) { }

  resolve(route: ActivatedRouteSnapshot): Observable<DynamicReportGeneralModel> {
    const reportId = route.paramMap.get('id');
    const reportType = route.queryParams['reportType'] ?? 'project';
    if (!reportId || isNaN(parseInt(reportId))) throw new Error('Report: Can not find id');
    const id = parseInt(reportId);

    try {
      return this._apiService.getById(id).pipe(map(e => e));
    } catch (error) {
      return throwError(() => error);
    }
  }
}
